import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

const updates = [
  { id: 'shanhai', chapter: '第 328 话', time: '2 小时前' },
  { id: 'shiguang', chapter: '第 88 话', time: '3 小时前' },
  { id: 'yunhai', chapter: '第 96 话', time: '5 小时前' },
  { id: 'tianpin', chapter: '第 44 话', time: '6 小时前' },
  { id: 'lingqi', chapter: '第 268 话', time: '8 小时前' },
  { id: 'xingchen', chapter: '第 76 话', time: '12 小时前' },
];

export default function NewUpdates() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            今日<span className="text-accent-500">新更</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">最新章节实时更新，追更不掉队</p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {updates.map((u) => {
          const comic = allComics.find((c) => c.id === u.id)!;
          return (
            <Link
              key={u.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-100 p-3 transition-all duration-300 hover:border-accent-300 hover:shadow-soft"
            >
              <img src={comic.cover} alt={`${comic.title}更新封面`} className="h-16 w-12 shrink-0 rounded-lg object-cover object-top" />
              <div className="min-w-0 flex-1">
                <h4 className="truncate font-medium text-foreground-950 group-hover:text-accent-600 transition-colors">
                  {comic.title}
                </h4>
                <p className="mt-1 text-xs text-foreground-500">
                  {comic.status === '连载中' ? `更新 ${u.chapter}` : `${comic.chapters} 话全`}
                </p>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                  {comic.status === '连载中' ? '更新中' : '已完结'}
                </span>
                <span className="text-xs text-foreground-400">{u.time}</span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}